import React from "react";
import DirectusCombobox from "./combobox";
import EvtMultiSelectBadges from "../multiselect";
import client from "directus/src/client";
import FilterWrapper from "components/filter/wrapper";

export default function GradesCombobox({
  filter,
  hideLabel,
  className,
  multiselect = false,
  required,
  ...props
}) {
  if (multiselect) {
    if (hideLabel) {
      return (
        <div className={className}>
          <EvtMultiSelectBadges
            collection="grades"
            fields={["id", "name"]}
            searchKeys={["name"]}
            filter={filter}
            placeholder="Select"
            {...props}
          />
        </div>
      );
    }

    return (
      <FilterWrapper label="Grade" className={className}>
        <EvtMultiSelectBadges
          collection="grades"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select"
          {...props}
        />
      </FilterWrapper>
    );
  }

  // Default single select behavior
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="grades"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select Grade"
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper label="Grade" className={className} required={required}>
      <DirectusCombobox
        client={client}
        collection="grades"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        limit={-1}
        {...props}
      />
    </FilterWrapper>
  );
}
